import type {
  ArenaContestResponse,
  TransformedArenaContestResponse
} from '@library/types/arenaContest';
import { api } from '@bo-services/api';
import { apiPaths } from '@bo-constants/services';
import { defaultHeaders } from '@bo-constants/apiHeaders';
import { transformArenaContestResponse } from '@bo-utils/arenaContest';

const { memberSupport } = apiPaths;

export const arenaConstestsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getArenaContestById: build.query<
      Array<TransformedArenaContestResponse>,
      { contest_id?: string }
    >({
      query: ({ contest_id }) => ({
        url: `${memberSupport}arena_contests/${contest_id}`,
        method: 'GET',
        headers: defaultHeaders
      }),
      transformResponse: (response: ArenaContestResponse) =>
        transformArenaContestResponse(response),
      providesTags: ['ArenaContest']
    })
  })
});

export const { useGetArenaContestByIdQuery } = arenaConstestsApi;
